import * as cn from 'classnames'
import * as styles from 'styles/atoms/buttons/ButtonRow.css'
import Button, { ButtonSize, ButtonProps } from 'components/features/pfm/Button/Button'

type ButtonRowProps = {
  buttons: ButtonProps[]
  size?: ButtonSize
  buttonsPerRow?: number // Can be set to auto size buttons
}

// TODO @pmyagkov refactor using `children` pattern
// Width and Size have defaults to keep rows consistent but can be overwritten for any button
const ButtonRow = ({ buttons, size, buttonsPerRow }: ButtonRowProps) => {
  const buttonCount = buttonsPerRow || buttons.length
  const width = (1 / buttonCount) * 100
  return (
    <ul className={ cn(styles.buttonRow, { [styles.singleButtonRow]: buttons.length === 1 }) }>
      {
        buttons.map((buttonProps: ButtonProps, index: number) => (
          <li key={ index } className={ styles.buttonWrapper } style={{ width: width + '%' }}>
            <Button fullWidth size={ size } { ...buttonProps } />
          </li>
        ))
      }
    </ul>
  )
}


export default ButtonRow
